/**
 * Production
 * A production configuration of an application with
 * all sub applications modules included.
 */
export const environment = {
    production: true,
    version: '1.0.0',
    apiUrl: 'https://api-integration.viessmann-climatesolutions.com/service-and-maintenance/appointment-booking',
    statusPage: 'https://api.viessmann-climatesolutions.com/status/v1/apps/kcgbz6v1ygp8/summary'
};
